<div class="active-carrier-app sec-gap">
  <div class="contact-dash white-bg">
    <div class="graph-header">
      <div class="left-part">
        <div class="graph-title">
            <h3 class="title">Errors & Omissions and Bonds <span class="numbers">({{eandoList?.length}})</span></h3>
        </div>
      </div>
      <div class="right-part">     
          <div class="action-block eando-section">
            
            <div class="select-options package ml-2" *ngIf="!currentPage && !isDeleted">
                <div class="select-block pb-1">
                    <ng-select [searchable]="true" [clearable]="true" name="branch" [(ngModel)]="eandOTypeId" placeholder="Add New"
                        class="form-control" (change)="redirectToEandO()">
                        <ng-option [value]='1'>
                            E&amp;O
                        </ng-option>
                        <ng-option [value]='2'>
                            Bond
                        </ng-option>
                    </ng-select>
                </div>
            </div>
          <span class="go-to-icon addlink" *ngIf="!currentPage && !isDeleted" (click)="loadURL()"><img title="Detail view" class="ver-middle"
              src="assets/images/go-to-detail.svg" /></span>
          <div class="more-info">
            <svg class="ic-more" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <rect id="Rectangle_657" data-name="Rectangle 657" width="20" height="20" fill="none" />
              <path id="more_vert_FILL0_wght400_GRAD0_opsz20"
                d="M10,16a1.5,1.5,0,1,1,1.062-.438A1.444,1.444,0,0,1,10,16Zm0-4.5A1.5,1.5,0,0,1,8.938,8.938a1.5,1.5,0,0,1,2.124,2.124A1.444,1.444,0,0,1,10,11.5ZM10,7A1.5,1.5,0,0,1,8.5,5.5a1.5,1.5,0,0,1,2.562-1.062,1.506,1.506,0,0,1,0,2.124A1.444,1.444,0,0,1,10,7Z"
                fill="#757575" />
            </svg>
          </div>
        </div>

      </div>
    </div>
    <div class="active-carrier-app-info dash-nipr-block pt-0">

      <div class="tab common-tab p-0 widget-tab" role="tabpanel">
        <ul class="nav nav-tabs sticky-top" role="tablist" (click)="getSelectedTab($event)">
            <li class="nav-item">
                <a class="nav-link active" (contextmenu)="$event.preventDefault()" href="#activeEandO" aria-controls="activeEandO" role="tab"
                    data-toggle="tab">Active</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (contextmenu)="$event.preventDefault()" href="#archivedEandO" aria-controls="archivedEandO" role="tab"
                    data-toggle="tab">Archived</a>
            </li>
        </ul>

        <div class="tab-content">
          <!-- Active Tab -->
            <!-- Active Tab -->
            <div *ngIf="activeTab == '#activeEandO'" role="tabpanel" class="tab-pane active in"
                id="activeEandO" style="height: 254px; overflow: auto;">

                <div class="common-table regularty-action alerts-details ra-dashboard p-0">
                    <table class="table regularty-action-table" *ngIf="eandoList?.length > 0">
                        <thead class="sticky-from-top">
                            <tr>
                                <th scope="col" [width]="50">
                                    Type
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'eandOType')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    <span class="max-width-tooltip-80">Account Type</span>
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'PolicyType')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Record Number
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'PolicyNumber')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Affiliated Agency
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'AgencyName')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    FEIN
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'AgencyFEIN')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    NPN
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'NPN')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Contract
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'Contract')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Carrier Name/Alias
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'CarrierName')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Issue Date
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'IssueDate')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Expiry Date
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'ExpiryDate')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    On File
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'OnFile')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Limit
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'EandOLimit')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Account Holder Name
                                    <img class="sorting-icon-asc"
                                        (click)="onSortClick($event, 'PolicyHolderName')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Account Holder Email
                                    <img class="sorting-icon-asc"
                                        (click)="onSortClick($event, 'PolicyHolderEmail')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Updated By
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'UpdatedBy')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Updated On
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'UpdatedDate')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Created By
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'CreatedBy')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">Created On <img class="sorting-icon-asc"
                                        (click)="onSortClick($event, 'CreatedDate')"
                                        src="assets/images/ic_ascending.svg" alt="" /></th>

                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let eando of eandoList;let i = index">
                                <tr class="parent-row whitespace" [class.row-highlight]="selectedRecordId == eando.eandOId" (click)="selectedRecordId = eando.eandOId">
                                    
                                    <td> {{eando.eandOType}}</td>
                                    <td>{{eando.policyType}}</td>
                                    <td>
                                        <div class="status-icon">
                                            <span class="max-width-tooltip-125"
                                                appEllipsifyMe>{{eando.policyNumber}}</span>
                                        </div>
                                    </td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.agencyName}}</span></td>
                                    <td>{{eando.agencyFEIN}}</td>
                                    <td>{{eando.npn}}</td>

                                    <td> {{eando.contract ? 'Yes' : eando.contract==false ? 'No' : ''}}</td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.carrierName}}</span></td>
                                    <td>{{eando.eandOIssueDate | date :'MM/dd/yyyy'}}</td>
                                    <td>{{eando.eandOExpiryDate | date :'MM/dd/yyyy'}}</td>
                                    <td>{{eando.eandOOnFile ? 'Yes' : eando.eandOOnFile==false ? 'No' : ''}}
                                    </td>
                                    <td>{{eando.eandOLimit | usdMoney}}</td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.policyHolderFirstName}}
                                            {{eando.policyHolderLastName}}</span></td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.policyHolderEmail}}</span></td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.updatedByName}}</span></td>
                                    <td>{{eando.updatedDate | date :'MM/dd/yyyy'}}</td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.createdByName}}</span></td>
                                    <td>{{eando.createdDate | date :'MM/dd/yyyy'}}</td>


                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                
                <app-no-data-found *ngIf="activeList && eandoList.length <= 0"
                    [isGraphDashboard]="'false_true_ _ _ Errors & Omissions and Bonds would be visible here.'"></app-no-data-found>
                <div class="common-loader mt-5" [hidden]="!showLoader" style="position: relative;">
                    <div class="loader-icon mt-5">
                        <img src="assets/images/common-loader.gif" alt="">
                    </div>
                </div>
                    </div>
            </div>
    
            <!-- Archived Tab -->
            <div *ngIf="activeTab == '#archivedEandO'" role="tabpanel" class="tab-pane active in"
                id="archivedEandO" style="height: 254px; overflow: auto;">
                
                <div class="common-table regularty-action alerts-details ra-dashboard p-0">
                    <table class="table regularty-action-table" *ngIf="eandoList?.length > 0">
                        <thead class="sticky-from-top">
                            <tr>
                                <th scope="col" [width]="50">
                                    Type
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'eandOType')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    <span class="max-width-tooltip-80">Account Type</span>
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'PolicyType')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Record Number
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'PolicyNumber')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Affiliated Agency
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'AgencyName')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    FEIN
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'AgencyFEIN')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    NPN
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'NPN')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Contract
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'Contract')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Carrier Name/Alias
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'CarrierName')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Issue Date
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'IssueDate')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Expiry Date
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'ExpiryDate')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    On File
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'OnFile')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Limit
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'EandOLimit')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Account Holder Name
                                    <img class="sorting-icon-asc"
                                        (click)="onSortClick($event, 'PolicyHolderName')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Account Holder Email
                                    <img class="sorting-icon-asc"
                                        (click)="onSortClick($event, 'PolicyHolderEmail')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Updated By
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'UpdatedBy')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Updated On
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'UpdatedDate')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">
                                    Created By
                                    <img class="sorting-icon-asc" (click)="onSortClick($event, 'CreatedBy')"
                                        src="assets/images/ic_ascending.svg" alt="" />
                                </th>
                                <th scope="col">Created On <img class="sorting-icon-asc"
                                        (click)="onSortClick($event, 'CreatedDate')"
                                        src="assets/images/ic_ascending.svg" alt="" /></th>
                                <th scope="col">Archived By</th>
                                <th scope="col">Archived On</th>

                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let eando of eandoList;let i = index">
                                <tr class="parent-row whitespace cursor-pointer" [class.row-highlight]="selectedRecordId == eando.eandOId" (click)="selectedRecordId = eando.eandOId">
                                    
                                    <td> {{eando.eandOType}}</td>
                                    <td>{{eando.policyType}}</td>
                                    <td>
                                        <div class="status-icon">
                                            <span class="max-width-tooltip-125"
                                                appEllipsifyMe>{{eando.policyNumber}}</span>
                                        </div>
                                    </td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.agencyName}}</span></td>
                                    <td>{{eando.agencyFEIN}}</td>
                                    <td>{{eando.npn}}</td>

                                    <td> {{eando.contract ? 'Yes' : eando.contract==false ? 'No' : ''}}</td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.carrierName}}</span></td>
                                    <td>{{eando.eandOIssueDate | date :'MM/dd/yyyy'}}</td>
                                    <td>{{eando.eandOExpiryDate | date :'MM/dd/yyyy'}}</td>
                                    <td>{{eando.eandOOnFile ? 'Yes' : eando.eandOOnFile==false ? 'No' : ''}}
                                    </td>
                                    <td>{{eando.eandOLimit | usdMoney}}</td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.policyHolderFirstName}}
                                            {{eando.policyHolderLastName}}</span></td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.policyHolderEmail}}</span></td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.updatedByName}}</span></td>
                                    <td>{{eando.updatedDate | date :'MM/dd/yyyy'}}</td>
                                    <td><span class="max-width-tooltip-150"
                                            appEllipsifyMe>{{eando.createdByName}}</span></td>
                                    <td>{{eando.createdDate | date :'MM/dd/yyyy'}}</td>

                                    <td><span class="max-width-tooltip-150" appEllipsifyMe>{{eando.archivedByName}}</span></td>
                                    <td>{{eando.archivedDate | date :'MM/dd/yyyy'}}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                
                <app-no-data-found *ngIf="activeList && eandoList.length <= 0"
                    [isGraphDashboard]="'false_true_ _ _ Archived Errors & Omissions and Bonds would be visible here.'"></app-no-data-found>
                <div class="common-loader mt-5" [hidden]="!showLoader" style="position: relative;">
                    <div class="loader-icon mt-5">
                        <img src="assets/images/common-loader.gif" alt="">
                    </div>
                </div>
                    </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
